import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=a25f887e&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=a25f887e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25f887e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a25f887e')) {
      api.createRecord('a25f887e', component.options)
    } else {
      api.reload('a25f887e', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=a25f887e&scoped=true&", function () {
      api.rerender('a25f887e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4ZCzvp4yJTIBb/JS/comp/PopupBox.vue"
export default component.exports